// extracted by mini-css-extract-plugin
export default {"spacing":"ClientDetailCardSkeleton_spacing__to184","cardsDiv":"ClientDetailCardSkeleton_cardsDiv__e-Oy9"};